// extracted by mini-css-extract-plugin
export default {"orderDetailWrapper":"styles_orderDetailWrapper__rRDif","productImageBox":"styles_productImageBox__QGTAo","orderDetailheader":"styles_orderDetailheader__oWDzd"};